
































































































































































import { Banner, LineItem } from "@/models/campaign";
import { Component, Vue, Prop } from "vue-property-decorator";
import UtilsAPI from "@/services/utils";
import { LineItemModule } from "@/store/lineItem";
import { LayoutModule } from "@/store/layout";
import FormValidations from "@/helpers/validations";
import { CampaignModule } from "@/store/campaign";
import CampaignsAPI from "@/services/campaigns";
import { UserModule } from "@/store/user";

@Component
export default class BannerForm extends Vue {
  @Prop({ default: false }) batch!: boolean;
  @Prop({ default: () => [] }) lineItems!: LineItem[];

  model: Banner = new Banner();
  isUpdate = false;
  loading = false;
  formValidations = new FormValidations();
  campaign_id?: string = "";
  line_item_id?: string = "";

  get isAdmin(): boolean {
    return UserModule.isAdmin;
  }

  created(): void {
    this.campaign_id = CampaignModule.getCurrentCampaign.id;

    if (!this.batch) {
      this.line_item_id = LineItemModule.getCurrentLineItem?.id;
      this.getBanner();
    }
  }

  async getBanner(): Promise<void> {
    try {
      const banner = await CampaignsAPI.lineItems.banners.get(
        this.campaign_id,
        this.line_item_id
      );
      this.model = new Banner(banner);

      this.isUpdate = true;
    } catch (e) {
      console.log(e);
    }
  }

  validate(): void {
    if (this.validateForm()) {
      this.batch ? this.batchSave() : this.save();
    }
  }

  async save(): Promise<void> {
    try {
      this.loading = true;
      await CampaignsAPI.lineItems.banners.new(
        this.model,
        this.campaign_id,
        this.line_item_id
      );

      LayoutModule.setAlerts({
        text: this.isUpdate
          ? this.$t("campaigns.responses.success_banner_update").toString()
          : this.$t("campaigns.responses.success_banner_create").toString(),
        type: "success",
      });

      LayoutModule.hideRightDrawer();
    } catch (e) {
      console.log(e);
    }

    this.loading = false;
  }

  // TODO: Migrar a endpoint batch
  async batchSave(): Promise<void> {
    try {
      this.loading = true;

      for (const lineItem of this.lineItems) {
        await CampaignsAPI.lineItems.banners.new(
          this.model,
          this.campaign_id,
          lineItem.id
        );
      }

      LayoutModule.setAlerts({
        text: this.isUpdate
          ? this.$t("campaigns.responses.success_banner_update").toString()
          : this.$t("campaigns.responses.success_banner_create").toString(),
        type: "success",
      });

      LayoutModule.hideRightDrawer();
    } catch (e) {
      console.log(e);
    }
    this.loading = false;

    // try {
    //   this.loading = true;
    //   const payload: BannerBatch = {
    //     lineItemIds: [],
    //     banner: this.model,
    //   };

    //   this.lineItems.forEach((lineItem: LineItem) => {
    //     payload.lineItemIds.push(lineItem.id ? lineItem.id : "");
    //   });

    //   await CampaignsAPI.lineItems.banners.batch(payload, this.campaign_id);
    //   LayoutModule.setAlerts({
    //     text: this.isUpdate
    //       ? this.$t("campaigns.responses.success_banner_update").toString()
    //       : this.$t("campaigns.responses.success_banner_create").toString(),
    //     type: "success",
    //   });

    //   LayoutModule.hideRightDrawer();
    // } catch (e) {
    //   console.log(e);
    // }
  }

  validateForm(): boolean {
    return (this.$refs.form as Vue & {
      validate: () => boolean;
    }).validate();
  }

  async generateUtmParams(): Promise<void> {
    const ad_unit_id = LineItemModule.getCurrentLineItem
      ? LineItemModule.getCurrentLineItem.adUnitId
      : "";

    if (this.validateForm()) {
      try {
        const url = await UtilsAPI.add_utm_params(
          this.model.targetUrl,
          ad_unit_id
        );

        this.model.targetUrl = url;
      } catch (e) {
        console.log(e);
      }
    }
  }

  async generateBitly(): Promise<void> {
    if (this.validateForm()) {
      const payload = {
        url: this.model.targetUrl,
      };
      const r = await UtilsAPI.shorten_url(payload);

      this.model.bitly = r.shortenUrl;
    }
  }

  loadBanner(e: File, type: string): void {
    if (e) {
      const reader = new FileReader();
      this.loading = true;
      reader.readAsDataURL(e);
      reader.onload = () => {
        this.loading = false;
        type === "desktop"
          ? (this.model.source = reader.result ? reader.result.toString() : "")
          : (this.model.source_mobile = reader.result
              ? reader.result.toString()
              : "");
        // this.model.source = reader.result ? reader.result.toString() : "";
      };
    } else {
      type === "desktop"
        ? (this.model.source = undefined)
        : (this.model.source_mobile = undefined);
    }
  }

  cancel(): void {
    LayoutModule.hideRightDrawer();
  }

  async new(): Promise<void> {
    //
  }

  isHtml(source: string): boolean {
    return source.includes(".html");
  }
}
